var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('YearSelector',{staticClass:"mb-3",on:{"select":_vm.setYear}}),_c('Table',{staticClass:"my-3",attrs:{"items":_vm.unpaid_items,"title":"Unpaid Orders"}}),_c('Table',{staticClass:"my-3",attrs:{"items":_vm.charged_items,"title":"Paid Orders"}}),_c('PaybyCheck')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }